import React from 'react';
import PropTypes from 'prop-types';
import TableHeader from './TableHeader';
import Schedule from './Schedule';
import DatePicker from 'react-date-picker';


const Table = ({
  title, button, items, onClickSchedule, activeDate,
  activeProduct, duration, children, timeStep, lang, pickerDate, pickerOnChange, masterData, bookingData,
    productId
}) => {
  const isLoading = false;
  const showOverlay = activeProduct === undefined;

  const LoadOverlay = (
    <div id="schedule-overlay" className="booking-overlay">
      <h2>
        {lang.pickAProductFirst}
      </h2>
    </div>
  );

  return (
    <div className="panel card">


      <div className="panel-heading">
        <div className="pull-left">
          <h3 className="panel-title">{title}</h3>

        </div>

        <div className="text-center" />
        {!masterData && (
            <DatePicker
                value={pickerDate}
                onChange={pickerOnChange}
                locale={lang.locale}
                minDate={new Date()}
                maxDate={new Date(new Date().setMonth(new Date().getMonth() + 11))}
                minDetail="month"
                clearIcon={lang.today}
            />
        )}


      </div>

      <div className="col-md-12 schedule">
        {isLoading ? LoadOverlay : ''}
        {showOverlay ? LoadOverlay : ''}


        <table className="table table-condensed table-booking App">
          <thead>
            <tr>
              {items.data.map(({ day, date }) => (

                <TableHeader
                  key={date}
                  day={day}
                  date={date}

                />
              ))}

            </tr>
          </thead>
          <tbody>
            <tr>

              {items.data.map((value, index) => (

                <Schedule
                  key={index}
                  items={value}
                  onDateChange={onClickSchedule}
                  duration={duration}
                  activeDate={activeDate}
                  resourceTimeStep={timeStep}
                  masterData={masterData}
                  bookingData={bookingData}
                  productId={productId}
                />
              ))}
            </tr>
          </tbody>
        </table>
      </div>

      <div className="panel-body">
        <div className="row">
          <div className="col-xs-4">

            <button
              className="btn btn-default btn-sm pull-left"
              onClick={() => button('-')}
            >
              {lang.prevWeek}
            </button>
          </div>
          <div className="col-xs-4" />
          <div className="col-xs-4">
            <button
              className="btn btn-default btn-sm pull-right"
              onClick={() => button('+')}
            >
              {lang.nextWeek}
            </button>
          </div>
        </div>


      </div>


    </div>
  );
};

Table.propTypes = {
  title: PropTypes.string.isRequired,
  items: PropTypes.object.isRequired,
  button: PropTypes.func.isRequired,
  onClickSchedule: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
};

export default Table;



// WEBPACK FOOTER //
// ./src/components/Resource/components/Table.jsx